import CircularProgress from '@material-ui/core/CircularProgress';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';
import LockOutlinedIcon from '@material-ui/icons/LockOutlined';
import { FC, MouseEvent, ReactNode } from 'react';
import { useHistory } from 'react-router-dom';
import { withBeneficiaryQuery } from '../../Tests/shared/adminResultNav';
import { redesignTheme } from '../../theme';
import locale from '../locale.json';
import { useResultCardStyles } from './ResultCard.styles';

interface ResultCardProps {
  visual: ReactNode;
  description: string;
  disable?: boolean;
  loading: boolean;
  to: string;
  toResultat: string;
  withAccess?: boolean;
  withoutAccessRedirectButton?: ReactNode;
  buyRedirectUri?: string;
  adminView?: boolean;
  beneficiaryId?: number | string;
}

const ResultCard: FC<ResultCardProps> = ({
  visual,
  description,
  disable = false,
  loading,
  to,
  toResultat,
  withAccess = true,
  withoutAccessRedirectButton,
  buyRedirectUri,
  adminView = false,
  beneficiaryId,
}) => {
  const classes = useResultCardStyles();
  const { push, location } = useHistory();

  const handleTakeTest = (e: MouseEvent) => {
    e.preventDefault();
    window.open(to, '_blank', 'noopener,noreferrer');
  };

  const handleViewResults = () => {
    if (disable) {
      return;
    }
    const resultPath = `${toResultat}?toBack=${location.pathname}`;
    push(adminView ? withBeneficiaryQuery(resultPath, beneficiaryId) : resultPath);
  };

  const handleBuyTest = () => {
    if (buyRedirectUri) {
      window.open(buyRedirectUri, '_blank', 'noopener,noreferrer');
    }
  };

  const isBuyAccessState = !!buyRedirectUri;

  if (loading) {
    return (
      <div className={classes.resultCard}>
        <div className={classes.cardLoader}>
          <CircularProgress />
        </div>
      </div>
    );
  }

  if (disable) {
    return (
      <div className={classes.resultCard}>
        <div
          style={{
            minHeight: 196,
            padding: '32px 40px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            boxSizing: 'border-box',
          }}>
          <div
            style={{
              width: '100%',
              maxWidth: 800,
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              gap: 16,
              textAlign: 'center',
            }}>
            <div
              style={{
                width: 56,
                height: 56,
                borderRadius: 40,
                backgroundColor: '#f2eee8',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}>
              <LockOutlinedIcon style={{ width: 24, height: 24, color: '#000000' }} />
            </div>

            <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
              <p
                style={{
                  margin: 0,
                  fontSize: 18,
                  fontFamily: redesignTheme.fonts.opensansBold,
                  color: '#000000',
                  lineHeight: 'normal',
                }}>
                {adminView
                  ? withAccess
                    ? locale.testNotTaken
                    : locale.testNotAssigned
                  : isBuyAccessState
                  ? "Vous n'avez pas encore accès à ce test"
                  : locale.noTestYet}
              </p>
              {!adminView && (
                <p
                  style={{
                    margin: 0,
                    fontSize: 18,
                    fontFamily: redesignTheme.fonts.opensans,
                    color: '#000000',
                    lineHeight: 'normal',
                  }}>
                  {isBuyAccessState ? locale.unlockTestDescription : locale.noTestYet}
                </p>
              )}
            </div>

            {adminView ? null : isBuyAccessState ? (
              <button
                type="button"
                className={classes.resultButton}
                style={{ alignSelf: 'center', padding: '0 40px' }}
                onClick={handleBuyTest}>
                {locale.buyTest}
              </button>
            ) : withAccess ? (
              <button
                type="button"
                className={classes.resultButton}
                style={{ alignSelf: 'center', padding: '0 40px' }}
                onClick={handleTakeTest}>
                {locale.takeTest}
              </button>
            ) : (
              withoutAccessRedirectButton || null
            )}
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className={classes.resultCard}>
      <div className={classes.resultCardInner}>
        <div className={classes.resultCardVisual}>{visual}</div>

        <div className={classes.resultCardBody}>
          <p className={classes.resultDescription}>{description}</p>
          <button type="button" className={classes.resultButton} onClick={handleViewResults}>
            {locale.viewResults}
            <ArrowForwardIcon className={classes.resultButtonIcon} />
          </button>
        </div>
      </div>
    </div>
  );
};

export default ResultCard;
